import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SubcompanyStatus from 'subcompanies/components/SubcompanyStatus';
import SubcompanyActions from 'subcompanies/components/SubcompanyActions';
import SubcompanyDelete from 'subcompanies/components/SubcompanyDelete';

const SubcompanyElement = ({
  canDelete,
  canEdit,
  canToggle,
  company,
  handleClick,
  handleDelete,
  handleToggle,
  subcompany,
}) => (
  <div className="col-sm-6 col-md-6 col-lg-4">
    <div
      className={classnames('card card-company mt-5 mb-5', {
        disabled: !subcompany.active,
      })}
      onClick={(e) => {
        e.preventDefault();
        handleClick(subcompany.id);
      }}
    >
      <SubcompanyDelete subcompany={subcompany} canDelete={canDelete} handleDelete={handleDelete} />
      <div className="text-center rounded-circle card-avatar">
        <i className="fa fa-building fa-3x" />
      </div>
      <div className="card-body mt-5 text-center">
        <h5 className="card-title mt-0">{subcompany.shortname}</h5>
        <p className="card-text">{subcompany.name}</p>
        <SubcompanyStatus isActive={subcompany.active} />
        <SubcompanyActions
          canEdit={canEdit}
          canToggle={canToggle}
          companyId={company.id}
          handleToggle={handleToggle}
          isLoading={!!subcompany.isLoading}
          subcompany={subcompany}
        />
      </div>
    </div>
  </div>
);

SubcompanyElement.propTypes = {
  canDelete: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  canToggle: PropTypes.bool.isRequired,
  company: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleToggle: PropTypes.func.isRequired,
  subcompany: PropTypes.object.isRequired,
};

export default SubcompanyElement;



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/components/SubcompanyElement.js